import { render } from "./AskAIPage.vue?vue&type=template&id=7f4c5c42&scoped=true"
import script from "./AskAIPage.vue?vue&type=script&lang=js"
export * from "./AskAIPage.vue?vue&type=script&lang=js"

import "./AskAIPage.vue?vue&type=style&index=0&id=7f4c5c42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4c5c42"]])

export default __exports__